import {
  image,
  headline,
  spacer,
  text,
  field,
  button,
  voucher,
} from '@components/Widgets/_contentItems/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import { type, maxWidth } from '@meta/widget/options'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Black Friday: 50% OFF',
  templateID: '18',
  description: 'Get ready for our biggest sale yet! Sign up now to receive a 50% discount and stay informed about our exclusive Black Friday deals.',
  tags: [typeTag.GAMIFICATION, tag.LEAD_GENERATION, tag.COUPONS_OFFERS],
}

const json = {
  id: 13,
  templateID: info.templateID,
  type: type.IMAGE_COLUMN,
  name: info.name,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.closeButtonColor = 'rgb(242, 248, 248)'

    customSettings.sideImage = (() => {
      const customSideImage = JSON.parse(JSON.stringify(image))
      customSideImage.content.url = 'https://assets.onvocado.com/templates/black-friday_side-image.webp'
      Object.assign(customSideImage.styling, {
        backgroundColor: 'rgba(0, 0, 0, 0)',
      })
      return customSideImage
    })()

    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling }
    customStyling.maxWidth = maxWidth.EXTRA_LARGE // "maxWidth": "720px"
    customStyling.backgroundColor = 'rgb(20, 20, 20)' // "backgroundColor": "rgb(20, 20, 20)"

    return customStyling
  })(),
  steps: [
    {
      id: 'pq5ocg6',
      contentItems: [
        // Image
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/black_friday-tag_white.webp'
          Object.assign(customImage.styling, {
            backgroundColor: 'rgba(0, 0, 0, 0)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
        // Spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        // Headline
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'SIGN UP FOR 50% OFF!'
          Object.assign(customHeadline.styling, {
            color: 'rgba(254, 254, 254, 1)',
            fontSize: '48px',
            textAlign: 'left',
            fontFamily: 'Ubuntu Mono',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        // Spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '20px'
          return customSpacer
        })(),
        // First Name Field
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'First Name'
          Object.assign(customField.styling, {
            color: 'rgba(13, 13, 13, 1)',
            fontSize: '20px',
            textAlign: 'left',
            fontFamily: 'Lato',
            fontWeight: '400',
            borderColor: 'rgba(0, 0, 0, 0.3)',
            borderWidth: '0px',
            borderRadius: '8px',
            backgroundColor: 'rgba(254, 254, 254, 1)',
          })
          customField.settings.type = 'text'
          customField.settings.label = 'First Name'
          customField.settings.required = true
          customField.settings.unique = false
          return customField
        })(),
        // Email Field
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Email'
          Object.assign(customField.styling, {
            color: 'rgba(13, 13, 13, 1)',
            fontSize: '20px',
            textAlign: 'left',
            fontFamily: 'Lato',
            fontWeight: '400',
            borderColor: 'rgba(0, 0, 0, 0.3)',
            borderWidth: '0px',
            borderRadius: '8px',
            backgroundColor: 'rgba(254, 254, 254, 1)',
          })
          customField.settings.type = 'email'
          customField.settings.label = 'Email address'
          customField.settings.required = true
          customField.settings.unique = false
          return customField
        })(),
        // Spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '10px'
          return customSpacer
        })(),
        // Button
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'GET DISCOUNT'
          Object.assign(customButton.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '18px',
            fontFamily: 'Lato',
            fontWeight: 'bold',
            borderColor: 'rgba(242, 248, 248, 1)',
            borderWidth: '2px',
            borderRadius: '2px',
            justifyContent: 'center',
            backgroundColor: 'rgba(20, 20, 20, 0)',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          customButton.settings.href = ''
          return customButton
        })(),
      ],
    },
    {
      id: '2e34gd7',
      contentItems: [
        // Image
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/black_friday-tag_white.webp'
          Object.assign(customImage.styling, {
            backgroundColor: 'rgba(55, 55, 55, 0)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
        // Headline
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'ENJOY YOUR 50% OFF'
          Object.assign(customHeadline.styling, {
            color: 'rgba(254, 254, 254, 1)',
            fontSize: '48px',
            textAlign: 'center',
            fontFamily: 'Ubuntu Mono',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        // Spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '10px'
          return customSpacer
        })(),
        // Voucher
        (() => {
          const customVoucher = JSON.parse(JSON.stringify(voucher))
          customVoucher.content.text = 'VOUCHER CODE'
          Object.assign(customVoucher.styling, {
            fontFamily: 'Ubuntu Mono',
            fontSize: '36px',
            fontWeight: 'bold',
            color: 'rgba(254, 254, 254, 1)',
            textAlign: 'center',
            borderRadius: '8px',
            borderWidth: '5px',
            borderColor: 'rgba(254, 254, 254, 1)',
          })
          return customVoucher
        })(),
        // text
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'An email with the best deals and savings is coming soon!'
          Object.assign(customText.styling, {
            color: 'rgba(254, 254, 254, 1)',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Lato',
          })
          return customText
        })(),
        // Spacer
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '14px'
          return customSpacer
        })(),
        // Button
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'CONTINUE SHOPPING'
          Object.assign(customButton.styling, {
            color: 'rgba(242, 248, 248, 1)',
            fontSize: '18px',
            fontFamily: 'Lato',
            fontWeight: 'bold',
            borderColor: 'rgba(242, 248, 248, 1)',
            borderWidth: '2px',
            borderRadius: '2px',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0)',
          })
          customButton.settings.action = 'close'
          customButton.settings.backBtn = false
          customButton.settings.href = ''
          return customButton
        })(),
      ],
    },
  ],
}

export { json, info }
